/* eslint-disable no-case-declarations */
/**
 * Documentation: docs/hooks/useActions.md
 *                docs/actions.md
 */

const debug = process.env.NODE_ENV === 'development' ? true : false

// Interfaces
import { Actions, ActionsMap, Payload } from '../interfaces/actions'

import { useNotifications } from './useNotifications'
import { useQueryClient } from 'react-query'
// Context
import { useUIContext } from '../context/UIContext'
import { queryKeyHRExpertMentors } from './useHRExpertMentors'

export const useActions = () => {
    const { notifyToObservers, toastNotification, setRotationInfo } = useUIContext()
    const { newNotification } = useNotifications()
    const queryClient = useQueryClient()

    const ActionsDispatch = async <A extends Actions>(actionType: A, ...payload: ActionsMap[A]) => {
        // eslint-disable-next-line no-console
        debug && console.info(`Dispatching action ${actionType} with payload:`, payload)

        switch (actionType) {
            case 'socket-new-incoming-notification':
                const [notification] = payload as Payload<'socket-new-incoming-notification'>
                newNotification(notification)
                break

            case 'new-rotation':
                const [{ courseId: courseID, enableLaunchAlgorithm, title, message, type }] =
                    payload as Payload<'new-rotation'>

                setRotationInfo({
                    inCourse: !enableLaunchAlgorithm,
                    title,
                    message,
                })

                if (!enableLaunchAlgorithm) return

                toastNotification(message, type, 3)
                queryClient.invalidateQueries([courseID], { exact: false })
                queryClient.invalidateQueries(['Team', courseID], { exact: false })
                queryClient.invalidateQueries(['Team', 'Timeline', courseID])

                break

            case 'meet-mentor-left':
            case 'meet-mentor-joined': {
                queryClient.invalidateQueries(queryKeyHRExpertMentors)

                break
            }

            case 'ui-content-has-updated': {
                const [{ courseId }] = payload as Payload<'ui-content-has-updated'>

                queryClient.invalidateQueries([courseId, 'Content'])
                queryClient.invalidateQueries(['Team', 'Content', courseId])

                notifyToObservers('ui-content-has-updated', payload)
                break
            }

            default:
                // Handle unknown action
                // eslint-disable-next-line no-console
                console.info(
                    `Can't dispatch unhandled action "${actionType}". This action will be notified to observers.`,
                    payload
                )
                notifyToObservers(actionType, payload)
                break
        }
    }

    return { ActionsDispatch }
}
